import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { CompareHelper } from '@barthauer/abc/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { BasysMapFrameService } from '@barthauer/basys/map-frame';
import { Subscription } from 'rxjs';
import { worksAnimation } from '../../animations';
import { AppService } from '../../services/app.service';
import { FrameService } from '../../services/frame.service';
import { MobileWorkViewModel } from '../../viewModels/mobileData.viewModel';
import { WorkNavigationContext } from '../works.model';
import { WorksService } from '../works.service';

@Component({
  selector: 'work-navigation',
  templateUrl: './work-navigation.component.html',
  animations: [worksAnimation],
  encapsulation: ViewEncapsulation.Emulated,
  styleUrls: ['./work-navigation.component.scss'],
  standalone: false,
})
export class WorkNavigationComponent implements OnInit, OnDestroy {
  public res = ResourceSet.Empty;
  public workNavigationContext: WorkNavigationContext;
  @Input() disabled: boolean;
  private subscriptions: Subscription[] = [];

  constructor(
    public frame: BasysMapFrameService,
    private frameService: FrameService,
    public worksService: WorksService,
    private resourceService: ResourceManagerService,
  ) {
    this.subscriptions.push(
      worksService.onNavigationContextRefresh().subscribe((context) => (this.workNavigationContext = context)),
    );
  }

  async ngOnInit() {
    this.res = await this.resourceService.getResourceSet('abc-maintenance-opera');
  }

  ngOnDestroy() {
    console.log('WorkNavigationComponent_destroy');
    this.subscriptions.forEach((element) => {
      element.unsubscribe();
    });
    this.frameService.dispose();
  }

  isNavDisabled(operation: 'increment' | 'decrement'): boolean {
    if (this.disabled) {
      return true;
    }

    const workIndex = this.workNavigationContext?.workIndex;
    const taskIndex = this.workNavigationContext?.taskIndex;
    const data: MobileWorkViewModel[] = <MobileWorkViewModel[]>(
      this.workNavigationContext.workDataContext.dataSource.data
    );
    switch (operation) {
      case 'increment':
        if (this.frame.routing.getCurrentConfig().designation === AppService.Route_WorkDetail) {
          return data[workIndex]?.id === data[Object.keys(data).slice(-1)[0]]?.id;
        } else {
          return this.isNavToTaskDisabled(operation, data, workIndex, taskIndex);
        }
      case 'decrement':
        if (this.frame.routing.getCurrentConfig().designation === AppService.Route_WorkDetail) {
          return workIndex === this.tryGetFirstWorkIndex(data, 0);
        } else {
          return this.isNavToTaskDisabled(operation, data, workIndex, taskIndex);
        }
    }
  }

  private tryGetFirstWorkIndex(data: MobileWorkViewModel[], index: number): number {
    if (this.workNavigationContext.workDataContext.dataSource?.filteredData?.length > index) {
      if (CompareHelper.isEmptyObject(data[index])) {
        index++;
        return this.tryGetFirstWorkIndex(data, index);
      }
      return index;
    } else {
      return -1;
    }
  }

  private isNavToTaskDisabled(
    operation: 'increment' | 'decrement',
    data: MobileWorkViewModel[],
    workIndex: number,
    taskIndex: number,
  ): boolean {
    const position =
      operation === 'increment' ? this.workNavigationContext?.work?.tasks?.filter((t) => t.isVisible)?.length - 1 : 0;
    if (taskIndex === position) {
      return true;
    }
    operation === 'increment' ? taskIndex++ : taskIndex--;
    const resultCategories = data[workIndex]?.tasks[taskIndex]?.resultCategories;
    if (CompareHelper.isEmptyObject(resultCategories)) {
      if (
        taskIndex >= 0 &&
        taskIndex < data[workIndex]?.tasks?.filter((t) => t.isVisible)?.length &&
        taskIndex !== position
      ) {
        return this.isNavToTaskDisabled(operation, data, workIndex, taskIndex);
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
}
